"use strict";

exports.__esModule = true;
exports.TranslatorSupplier = exports.TranslatorContext = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TranslatorContext = exports.TranslatorContext = /*#__PURE__*/_react["default"].createContext({});

/**
 * Translates messages and provides access to React Intl via a render prop.
 */
var TranslatorSupplier = exports.TranslatorSupplier = function TranslatorSupplier(props) {
  var intl = (0, _reactIntl.useIntl)();
  var translate = function translate(id, defaultMessage, values) {
    if (values === void 0) {
      values = {};
    }
    var descriptor = {
      id: id,
      defaultMessage: defaultMessage
    };
    return intl.formatMessage(descriptor, values);
  };
  var consumerProps = {
    intl: intl,
    translate: translate
  };
  return /*#__PURE__*/_react["default"].createElement(TranslatorContext.Provider, {
    value: consumerProps
  }, props.children);
};